import React, { useEffect, useRef, useState } from 'react';
import { BaseInput } from '../../base';
import { validateLatin1String } from '../../../utils';
import { useLatin1ValidationContext } from '../../contexts/latin1-validation-context';
import * as S from './compose-input.styles';

export interface IComposeInputProps {
    onChange: (subject: string) => void;
    onValidationChange?: (hasError: boolean) => void;
    disabled?: boolean;
    isNote?: boolean;
    maxLength?: number;
    subject?: string;
}

export const ComposeInput: React.FunctionComponent<IComposeInputProps> = (
    props: IComposeInputProps,
): React.ReactElement => {
    const { onChange, onValidationChange, disabled, isNote, maxLength, subject } = props;
    const [latin1ValidationError, setLatin1ValidationError] = useState<string | null>(null);

    const { registerError } = useLatin1ValidationContext();
    const inputIdRef = useRef<string>(`compose-input-${Math.random().toString(36).substr(2, 9)}`);

    useEffect(() => {
        return () => {
            // Clear error on unmount
            registerError(inputIdRef.current, '', null);
        };
    }, [registerError]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newSubject = e.target.value;
        onChange(newSubject);
        // Clear validation error when user starts typing
        if (latin1ValidationError) {
            setLatin1ValidationError(null);
            onValidationChange?.(false);
            registerError(inputIdRef.current, 'Subject', null);
        }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
        // Validate on blur
        const value = e.target.value;
        const validationResult = validateLatin1String(value);
        const error = validationResult.isValid ? null : validationResult.errorMessage || null;

        setLatin1ValidationError(error);
        const fieldName = 'Subject';
        registerError(inputIdRef.current, fieldName, error);
        onValidationChange?.(!!error);
    };

    return (
        <S.Container>
            <S.Label>Subject</S.Label>
            <BaseInput
                disabled={disabled}
                placeholder="What's this about?"
                value={subject || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={maxLength || 80}
                disableLatin1Validation={true}
                errorMessage={latin1ValidationError || undefined}
            />
        </S.Container>
    );
};
